import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertyParkingSubType } from '@workspace/data-types';
import { AuraNumberInputComponent } from '@workspace/ng-aura';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';
import { PropertyCharacteristicsForm, PropertyParkingForm } from '../../../types/property-form.types';

@Component({
  selector: 'etxe-property-parking-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    EtxeEnumDisplayPipe,
    AuraNumberInputComponent,
  ],
  templateUrl: './parking-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyParkingListComponent {
  form = input.required<FormGroup<PropertyCharacteristicsForm>>();
  showLotNumber = input<boolean>(false);

  parkingTypes = Object.values(PropertyParkingSubType);

  get parkings() {
    return this.form().controls.parkings;
  }

  isParkingSelected(type: PropertyParkingSubType): boolean {
    return this.parkings.controls.some((c) => c.controls.type.value === type);
  }

  getParkingControl(type: PropertyParkingSubType): FormGroup<PropertyParkingForm> | undefined {
    return this.parkings.controls.find(
      (c) => c.controls.type.value === type,
    ) as FormGroup<PropertyParkingForm>;
  }

  toggleParkingType(type: PropertyParkingSubType) {
    const index = this.parkings.controls.findIndex((c) => c.controls.type.value === type);
    if (index !== -1) {
      this.parkings.removeAt(index);
    } else {
      this.parkings.push(
        new FormGroup({
          type: new FormControl<PropertyParkingSubType | null>(type),
          count: new FormControl<number | null>(1),
          totalSurface: new FormControl<number | null>(0),
          lotNumber: new FormControl<string | null>(''),
        }) as FormGroup<PropertyParkingForm>,
      );
    }
  }

  onUpdateCount(type: PropertyParkingSubType, count: number) {
    this.getParkingControl(type)?.controls.count.setValue(count);
  }

  onUpdateSurface(type: PropertyParkingSubType, surface: number) {
    this.getParkingControl(type)?.controls.totalSurface.setValue(surface);
  }

  onUpdateLotNumber(type: PropertyParkingSubType, lotNumber: string) {
    this.getParkingControl(type)?.controls.lotNumber.setValue(lotNumber);
  }
}
